import { createAsyncThunk } from '@reduxjs/toolkit';

import { OrderTableSchema } from '../../types/OrderTableSchema';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export const fetchOrdersCounters = createAsyncThunk<
    OrderTableSchema['counters'],
    string,
    ThunkConfig<string>
>('order/fetchOrdersCounters', async (propertyId, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
        const response = await extra.api.get<OrderTableSchema['counters']>(
            `/v1/orders/stats`,
            {
                params: { propertyId },
            },
        );

        return response.data;
    } catch (e) {
        return rejectWithValue('error');
    }
});
